import Http from '@/common/http'
class Qrcode {
  static getList (param = {}) {
    return Http.post('/mp/qrcode/getList', param)
  }
  static getTagList (param = {}) {
    return Http.post('/mp/qrcode/getTagList', param)
  }
  static doSubmit (param = {}) {
    return Http.post('/mp/qrcode/doSubmit', param)
  }
  static getQrcodeImage (param = {}) {
    return Http.post('/mp/qrcode/getQrcodeImage', param)
  }
  static downloadQrcode (param = {}) {
    return Http.post('/mp/qrcode/downloadQrcode', param)
  }
}
class Material {
  static getList (param = {}) {
    return Http.get('/mp/material/getList', param)
  }
  static doSubmitMedia (param = {}) {
    return Http.post('/mp/material/doSubmitMedia', param)
  }
  static delWxMaterial (param = {}) {
    return Http.get('/mp/material/delWxMaterial', param)
  }
  static syncWxMaterial (param = {}) {
    return Http.post('/mp/material/syncWxMaterial', param)
  }
  static syncOneNews (param = {}) {
    return Http.post('/mp/material/syncOneNews', param)
  }
  static submitDraft (param = {}) {
    return Http.post('/mp/material/submitDraft', param)
  }
}
class Reply {
  static getMaterialLocalList (param = {}) {
    return Http.get('/mp/local_material/getMaterialLocalList', param)
  }
  static uploadMaterial (param = {}) {
    return Http.get('/mp/local_material/uploadMaterial', param)
  }
  static saveLocalMaterialInfo (param = {}) {
    return Http.post('/mp/local_material/saveLocalMaterialInfo', param)
  }
  static delLocalMaterial (param = {}) {
    return Http.get('/mp/local_material/delLocalMaterial', param)
  }
  static previewMessage (param = {}) {
    return Http.get('/mp/local_material/previewMessage', param)
  }
}
class System {
  static getMaterialList (param = {}) {
    return Http.get('/mp/auto_reply/getMaterialList', param)
  }
  static getTypeList (param = {}) {
    return Http.get('/mp/auto_reply/getTypeList', param)
  }
  static getAutoReplyList (param = {}) {
    return Http.get('/mp/auto_reply/getAutoReplyList', param)
  }
  static getMaterialLocalList (param = {}) {
    return Http.get('/mp/auto_reply/getMaterialLocalList', param)
  }
  static getMaterialMediaList (param = {}) {
    return Http.get('/mp/auto_reply/getMaterialMediaList', param)
  }
  static getMaterialNewsList (param = {}) {
    return Http.get('/mp/auto_reply/getMaterialNewsList', param)
  }
  static saveAutoReply (param = {}) {
    return Http.post('/mp/auto_reply/saveAutoReply', param)
  }
  static decodeContent (param = {}) {
    return Http.get('/mp/auto_reply/decodeContent', param)
  }
  static getErrorList (param = {}) {
    return Http.get('/mp/auto_reply/getErrorList', param)
  }
  static getMenuClickList (param = {}) {
    return Http.get('/mp/auto_reply/getMenuClickList', param)
  }
  static getQrcodeList (param = {}) {
    return Http.get('/mp/auto_reply/getQrcodeList', param)
  }
  static copyAutoReply (param = {}) {
    return Http.post('/mp/auto_reply/copyAutoReply', param)
  }
  static getArticleList (param = {}) {
    return Http.get('/mp/article_tag/getArticleList', param)
  }
  static getRefDateList (param = {}) {
    return Http.get('/mp/article_tag/getRefDateList', param)
  }
  static getTagList (param = {}) {
    return Http.get('/mp/article_tag/getTagList', param)
  }
  static doSubmit (param = {}) {
    return Http.post('/mp/article_tag/doSubmit', param)
  }
  static getFilterPackageList (param = {}) {
    return Http.post('/mp/auto_reply/getFilterPackageList', param)
  }
  static ShortUrlGetList (param = {}) {
    return Http.post('/mp/shorturl/getList', param)
  }
  static ShortUrlDoSubmit (param = {}) {
    return Http.post('/mp/shorturl/doSubmit', param)
  }
}
class Mass {
  static getMassList (param = {}) {
    return Http.get('/mp/mass/getMassList', param)
  }
  static getStatusList (param = {}) {
    return Http.get('/mp/mass/getStatusList', param)
  }
  static getMsgTypeList (param = {}) {
    return Http.get('/mp/mass/getMsgTypeList', param)
  }
  static getFilterTypeList (param = {}) {
    return Http.get('/mp/mass/getFilterTypeList', param)
  }
  static getMaterialMediaList (param = {}) {
    return Http.get('/mp/mass/getMaterialMediaList', param)
  }
  static getMaterialNewsList (param = {}) {
    return Http.get('/mp/mass/getMaterialNewsList', param)
  }
  static getGroupList (param = {}) {
    return Http.get('/mp/mass/getGroupList', param)
  }
  static saveMass (param = {}) {
    return Http.post('/mp/mass/saveMass', param)
  }
  static previewMass (param = {}) {
    return Http.post('/mp/mass/previewMass', param)
  }
  static deleteMass (param = {}) {
    return Http.post('/mp/mass/deleteMass', param)
  }
  static decodeContent (param = {}) {
    return Http.post('/mp/mass/decodeContent', param)
  }
  static updateSendStatus (param = {}) {
    return Http.get('/mp/mass/updateSendStatus', param)
  }
}
class Template {
  static getTemplateSendTask (param = {}) {
    return Http.get('/mp/template/getTemplateSendTask', param)
  }
  static getTemplateList (param = {}) {
    return Http.get('/mp/template/getTemplateList', param)
  }
  static syncTemplateList (param = {}) {
    return Http.get('/mp/template/syncTemplateList', param)
  }
  static getTemplateFields (param = {}) {
    return Http.get('/mp/template/getTemplateFields', param)
  }
  static saveTemplateSendTask (param = {}) {
    return Http.post('/mp/template/saveTemplateSendTask', param)
  }
  static delTask (param = {}) {
    return Http.get('/mp/template/delTask', param)
  }
  static getFilterTypeList (param = {}) {
    return Http.get('/mp/template/getFilterTypeList', param)
  }
  static getUserFilterList (param = {}) {
    return Http.post('/mp/template/getUserFilterList', param)
  }
  static getUserFilterCount (param = {}) {
    return Http.post('/mp/template/getUserFilterCount', param)
  }
  static previewTemplate (param = {}) {
    return Http.post('/mp/template/previewTemplate', param)
  }
  static getStatusList (param = {}) {
    return Http.get('/mp/template/getStatusList', param)
  }
  static getTaskDetail (param = {}) {
    return Http.get('/mp/template/getTaskDetail', param)
  }
}
class Message {
  static getMessageSendTask (param = {}) {
    return Http.get('/mp/Message_Task/getMessageSendTask', param)
  }
  static getStatusList (param = {}) {
    return Http.get('/mp/Message_Task/getStatusList', param)
  }
  static saveMessageSendTask (param = {}) {
    return Http.post('/mp/Message_Task/saveMessageSendTask', param)
  }
  static delTask (param = {}) {
    return Http.get('/mp/Message_Task/delTask', param)
  }
  static previewMessage (param = {}) {
    return Http.post('/mp/Message_Task/previewMessage', param)
  }
  static getUserFilterList (param = {}) {
    return Http.post('/mp/Message_Task/getUserFilterList', param)
  }
  static getUserFilterCount (param = {}) {
    return Http.post('/mp/Message_Task/getUserFilterCount', param)
  }
  static getFilterTypeList (param = {}) {
    return Http.get('/mp/Message_Task/getFilterTypeList', param)
  }
  static decodeContent (param = {}) {
    return Http.get('/mp/Message_Task/decodeContent', param)
  }
}
class Custom {
  static getUserFilterList (param = {}) {
    return Http.post('/mp/tag/getUserFilterList', param)
  }
  static getTaskPushLog (param = {}) {
    return Http.post('/mp/auto_push/getTaskPushLog', param)
  }
  static getUserFilterCount (param = {}) {
    return Http.post('/mp/tag/getUserFilterCount', param)
  }
  static getUserTagTask (param = {}) {
    return Http.post('/mp/tag/getUserTagTask', param)
  }
  static getTagList (param = {}) {
    return Http.post('/mp/tag/getTagList', param)
  }
  static saveUserTagTask (param = {}) {
    return Http.post('/mp/tag/saveUserTagTask', param)
  }
  static delUserTagTask (param = {}) {
    return Http.post('/mp/tag/delUserTagTask', param)
  }
  static getMpFilterCriteria (param = {}) {
    return Http.post('/mp/package/getMpFilterCriteria', param)
  }
  static getPackageRelationSetting (param = {}) {
    return Http.post('/mp/package/getPackageRelationSetting', param)
  }
  static getPackageList (param = {}) {
    return Http.post('/mp/package/getPackageList', param)
  }
  static getPackageStatusList (param = {}) {
    return Http.post('/mp/package/getPackageStatusList', param)
  }
  static getPackageDetail (param = {}) {
    return Http.post('/mp/package/getPackageDetail', param)
  }
  static savePackageInfo (param = {}) {
    return Http.post('/mp/package/savePackageInfo', param)
  }
  static savePackageInfoByUpload (param = {}) {
    return Http.post('/mp/package/savePackageInfoByUpload', param)
  }
  static getMpAutoPushCriteria (param = {}) {
    return Http.post('/mp/auto_push/getMpAutoPushCriteria', param)
  }
  static getAutoPushTaskList (param = {}) {
    return Http.post('/mp/auto_push/getAutoPushTaskList', param)
  }
  static saveAutoPushInfo (param = {}) {
    return Http.post('/mp/auto_push/saveAutoPushInfo', param)
  }
  static decodeContent (param = {}) {
    return Http.post('/mp/auto_push/decodeContent', param)
  }
  static delAutoPushInfo (param = {}) {
    return Http.post('/mp/auto_push/delAutoPushInfo', param)
  }
  static updateTaskStatus (param = {}) {
    return Http.post('/mp/auto_push/updateTaskStatus', param)
  }
}
class TrackReply {
  static getAutoTemplateList (param = {}) {
    return Http.get('/mp/auto_template/getAutoTemplateList', param)
  }
  static getStatusList (param = {}) {
    return Http.get('/mp/auto_template/getStatusList', param)
  }
  static getTypeList (param = {}) {
    return Http.get('/mp/auto_template/getTypeList', param)
  }
  static getEventIdList (param = {}) {
    return Http.get('/mp/auto_template/getEventIdList', param)
  }
  static getTemplateList (param = {}) {
    return Http.get('/mp/auto_template/getTemplateList', param)
  }
  static getTemplateFields (param = {}) {
    return Http.get('/mp/template/getTemplateFields', param)
  }
  static saveAutoReply (param = {}) {
    return Http.post('/mp/auto_template/saveAutoReply', param)
  }
  static getSendTypeList (param = {}) {
    return Http.post('/mp/automatic_marketing/getSendTypeList', param)
  }
  static getTaskList (param = {}) {
    return Http.post('/mp/automatic_marketing/getTaskList', param)
  }
  static getTaskFilterList (param = {}) {
    return Http.post('/mp/automatic_marketing/getTaskFilterList', param)
  }
  static saveTask (param = {}) {
    return Http.post('/mp/automatic_marketing/saveTask', param)
  }
  static updateTaskStatus (param = {}) {
    return Http.post('/mp/automatic_marketing/updateTaskStatus', param)
  }
  static decodeContent (param = {}) {
    return Http.post('/mp/automatic_marketing/decodeContent', param)
  }
  static clearFilterCache (param = {}) { // 清空搜索条件缓存
    return Http.post('/mp/automatic_marketing/clearFilterCache', param)
  }
}
class Menu {
  static getMaterialLocalList (param = {}) {
    return Http.get('/mp/menu/getMaterialLocalList', param)
  }
  static getMaterialMediaList (param = {}) {
    return Http.get('/mp/menu/getMaterialMediaList', param)
  }
  static getMaterialNewsList (param = {}) {
    return Http.get('/mp/menu/getMaterialNewsList', param)
  }
  static decodeContent (param = {}) {
    return Http.get('/mp/menu/decodeContent', param)
  }
  static getMenuSettingList (param = {}) {
    return Http.get('/mp/menu/getMenuSettingList', param)
  }
  static saveMenuSetting (param = {}) {
    return Http.post('/mp/menu/saveMenuSetting', param)
  }
  static getMenuGroupList (param = {}) {
    return Http.get('/mp/menu/getMenuGroupList', param)
  }
  static copyMenu (param = {}) {
    return Http.get('/mp/menu/copyMenu', param)
  }
}
class MenuGroup {
  static getMenuGroupList (param = {}) {
    return Http.get('/mp/menu_group/getMenuGroupList', param)
  }
  static decodeContent (param = {}) {
    return Http.get('/mp/menu_group/decodeContent', param)
  }
  static saveMenuGroup (param = {}) {
    return Http.post('/mp/menu_group/saveMenuGroup', param)
  }
  static pushMenuGroup (param = {}) {
    return Http.post('/mp/menu_group/pushMenuGroup', param)
  }
}
class UserGroup {
  static sync (param = {}) {
    return Http.get('/mp/group/syncGroupList', param)
  }
  static list (param = {}) {
    return Http.get('/mp/group/getGroupList', param)
  }
  static del (param = {}) {
    return Http.get('/mp/group/delGroup', param)
  }
  static doSubmit (param = {}) {
    return Http.post('/mp/group/doSubmit', param)
  }
  static getGroupAllotTask (param = {}) {
    return Http.post('/mp/group/getGroupAllotTask', param)
  }
  static getFIlterList (param = {}) {
    return Http.post('/mp/group/getFIlterList', param)
  }
  static getUserFilterList (param = {}) {
    return Http.post('/mp/group/getUserFilterList', param)
  }
  static getUserFilterCount (param = {}) {
    return Http.post('/mp/group/getUserFilterCount', param)
  }
  static saveGroupAllotTask (param = {}) {
    return Http.post('/mp/group/saveGroupAllotTask', param)
  }
}
export default {
  Qrcode,
  Material,
  Reply,
  System,
  Menu,
  MenuGroup,
  UserGroup,
  Mass,
  Template,
  Message,
  TrackReply,
  Custom
}
